<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-col :span="22">
            <el-form
              size="medium"
              :inline="true"
              :model="searchCondition"
              class="demo-form-inline"
            >
              <el-form-item label="时间"
                ><DatePicker @dataSearch="dataSearch"
              /></el-form-item>
              <el-form-item
                ><el-button type="primary" @click="searchButton"
                  >查询</el-button
                ></el-form-item
              >
            </el-form>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" size="medium" @click="applyInvoice"
              >批量提交
            </el-button>
          </el-col>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          @selectList="selectList"
          highlight-current-row
        >
          <el-table-column slot="first-column" type="selection">
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import { mapGetters, mapState } from "vuex";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
  },
  data() {
    return {
      idList: [],
      searchCondition: {},
      downloadLoading: false,
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      //导出表格类型
      bookType: "xlsx",
      loadingStaus: true,
      columns: [
        {
          title: "编号",
          value: "outer_trade_no",
          header_align: "center",
          align: "center",
        },
        {
          title: "充值时间",
          value: "created_at",
          header_align: "center",
          align: "center",
          /*  width: 180, */
        },
        {
          title: "充值金额",
          width: 200,
          value: "money",
          header_align: "center",
          align: "center",
        },
      ],
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        // direction: 'right',
        title: "",
        width_height: "640px",
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      isAlipay: (state) => state.switchInfo.isAlipay,
    }),
  },
  methods: {
    //申请开票
    applyInvoice() {
      if(!this.idList.length){
        this.$message.warning('请选择一条记录')
        return;
      }
      this.$storage.set('ytBatchId', JSON.stringify(this.idList));
      this.$router.push({
        path: "/invoice/apply",
        query: { save: "save", isLaowuCompany: 0,yt:1 },
      });
    },
    //选中多选按钮
    async selectList(list) {
      this.idList = [];
      list.forEach((item) => {
        this.idList.push({ id: item.id, money: item.money,outer_trade_no:item.outer_trade_no });
      });
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化
    async init(type) {
      let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
        page_size: 10,
        current_page: 1,
      };
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.invoiceRechargeList(
        searchCondition
      );
      if (type == "export") {
        return data;
      } else {
        this.dataList = data;

        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped></style>
